import { IvrFlowType } from '../types'
import { NOT_LOGGED_IN } from '../errors'

type SuccessFallbackType = Array<unknown> | Object
type ErrorFallbackType = { message?: string } & {
  [k: string]: unknown | undefined
}

export default function kycGetGetter<
  SuccessResponse = SuccessFallbackType,
  ErrorResponse extends ErrorFallbackType = ErrorFallbackType,
>(urlGetter: (flowType: IvrFlowType) => string) {
  return async function kycGet(
    flowType: IvrFlowType = 'US_STOCKS_SBM',
    authToken: string,
  ) {
    const response = await fetch(urlGetter(flowType), {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })

    let json: ErrorResponse | SuccessResponse

    // TODO: extract this logic out to reuse, defering it because it's hard to extract things out in typescript quickly
    if (response.ok) {
      json = await response.json()
    } else if (response.status === 401) {
      throw new Error(NOT_LOGGED_IN)
    } else {
      json = (await response.json()) as ErrorResponse // TODO: see how to handle this better without asserting

      if (json.message) {
        throw new Error(json.message)
      } else {
        throw new Error('something went wrong')
      }
    }

    return json
  }
}
